import styled from "@emotion/styled";

export const CancelContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px;
  gap: 20px;
`;

export const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TagSection = styled.div`
  display: flex;
  justify-content: start;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
  gap: 8px;

  box-sizing: border-box;
  border-bottom: 1px solid var(--alias-color-line-normal);
`;

export const GoogleInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ResourceFrame = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const PrivateInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Label = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Image = styled.img`
  height: 320px;
  border-radius: 16px;
  border: 1px solid var(--alias-color-line-normal);
`;

export const EmptyImage = styled.div`
  height: 320px;
  border-radius: 16px;
  border: 1px solid var(--alias-color-line-normal);
  background-color: var(--component-color-fill-normal);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InfoItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
`;
